<template>
  <div class="row h-128">

    <article class="col-auto h-100 ms-auto">
      <div class="card h-100">
        <div class="card-body d-flex flex-column justify-content-between">
          <div class="row mb-3">
            <div class="col">
              <div class="card-text fw-bold">Paiement par virement</div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col">
              <p>Montant : {{ cart.totals.grand_total }}</p>
              <p>FR76 3000 3043 9300 0200 2510 306</p>
            </div>
          </div>

        </div>
      </div>
    </article>

    <action-button :icon="'bi-bag-check'" :text="'Valider\n la commande'" :color="'white'" :type="'success'" @click="placeOrder" />

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ActionButton from '@/components/common/ActionButton';

export default {
  props: {
    paymentMethod: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      paid: null,
    };
  },
  components: {
    ActionButton,
  },
  computed: {
    ...mapGetters('cart', ['cart']),
  },
  methods: {
    ...mapActions('alerts', ['setAlert']),
    placeOrder() {
      this.$emit('place-order', { paymentMethod: { method: this.paymentMethod }});
    },
  },
};
</script>
